import React from 'react'
import styled from 'styled-components'
import IconFB from '../../images/fb-icon-contact.svg'
import IconFBLarge from '../../images/fb-icon-large.svg'
import SocialIcons from '../shared/socialIcons'
import posed from 'react-pose'

const ContactSectionAnimation = posed.div({
  open: { y: 0, opacity: 1 },
  closed: { y: -50, opacity: 0 },
})

const ContactSectionInner = styled.div`
  background-color: #f2f2f2;
  background-image: url(${props => props.bg});
  background-repeat: no-repeat;
  background-position: center 15px;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 60px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  position: relative;
  top: -80px;
  @media (max-width: 1280px) {
    margin: 0 20px;
  }
  .details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 80px;
    margin: 30px 0 60px 0;
    text-align: left;
    a:first-child {
      text-align: right;
      grid-template-columns: 1fr 135px;
      grid-gap: 15px;
      justify-items: right;
    }
    a {
      display: grid;
      width: auto;
      font-size: 23px;
      color: #7b7782;
      grid-template-columns: 40px 165px;
      grid-gap: 15px;
      align-items: center;
      svg {
        width: 40px;
        height: 40px;
      }
      span {
        transition: all 0.2s ease-in-out;
        position: relative;
      }
      span:before {
        content: '';
        position: absolute;
        width: 100%;
        height: 4px;
        bottom: -4px;
        left: 0;
        background-color: ${props => props.colour};
        visibility: hidden;
        transform: scaleX(0);
        transform-origin: 0;
        transition: all 0.2s ease-in-out;
        transition-delay: 200ms;
      }
      svg #IconPhone,
      svg #IconEmail {
        transition: all 0.6s ease-in-out;
      }
      &:hover {
        color: #261f32;
        svg #IconPhone,
        svg #IconEmail {
          fill: #7b7782;
        }
      }
      &:hover span:before {
        visibility: visible;
        transform: scaleX(1);
      }
    }
  }
  @media (max-width: 600px) {
    background-position: center center;
    .details {
      margin: 30px 0;
      grid-template-columns: 1fr;
      grid-gap: 30px;
      justify-items: center;
      a {
        grid-template-columns: 40px 160px !important;
        font-size: 20px;
        span {
          justify-self: flex-start;
        }
      }
    }
    padding: 20px;
  }
`

const ContactSection = ({ colour, isVisible }) => (
  <ContactSectionAnimation pose={isVisible ? 'open' : 'closed'}>
    <ContactSectionInner bg={IconFBLarge} colour={colour}>
      <img src={IconFB} alt="Francois Brill" />
      <div className="details">
        <a href="mailto:f@brill.co.za">
          <svg
            width="50px"
            height="49px"
            viewBox="0 0 50 49"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Icon Email</title>
            <g
              id="Layouts"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="IconEmail"
                transform="translate(-793.000000, -8783.000000)"
                fill={colour}
                fillRule="nonzero"
              >
                <g
                  id="Contact-Section"
                  transform="translate(0.000000, 1602.000000)"
                >
                  <g
                    id="Group-5"
                    transform="translate(100.000000, 7003.000000)"
                  >
                    <g
                      id="Group-2"
                      transform="translate(693.000000, 177.000000)"
                    >
                      <path
                        d="M24.9999404,1.03135245 C29.4270127,1.03135245 33.4960139,1.99163612 37.2069425,3.91220495 C40.9178712,5.83277379 43.8150002,8.48576126 45.8983281,11.8711704 C48.111865,15.386787 49.2186327,19.3255792 49.2186327,23.6875484 C49.2186327,27.8542057 47.9491044,31.1094057 45.410048,33.4531501 C42.740784,35.9922066 38.8345433,37.2617348 33.6913259,37.2617348 C32.3241417,37.2617348 31.233649,36.9036623 30.4198493,36.1875186 C29.6060497,35.471375 29.1991491,34.4622618 29.1991491,33.1601821 C28.3527965,34.3971588 27.2460288,35.438822 25.8788445,36.2851746 C24.2512438,37.2617348 22.55854,37.7500149 20.8007317,37.7500149 C18.0012587,37.7500149 15.8202748,36.9036623 14.2577785,35.2109585 C12.6952822,33.5182547 11.9140341,31.1745102 11.9140341,28.1797252 C11.9140341,25.1849402 12.5650747,22.4831247 13.8671544,20.0742758 C15.0390266,17.7956359 16.6177994,16.0052746 18.6034713,14.7031948 C20.5891431,13.4011151 22.6887475,12.7500745 24.9022844,12.7500745 C26.5949882,12.7500745 28.0761049,13.1244221 29.3456332,13.8731187 C30.6151614,14.6218153 31.5428935,15.6472035 32.1288296,16.9492832 C32.1939342,16.2982426 32.2915902,15.6146505 32.4217977,14.8985069 L32.5194537,14.5078828 C32.5194537,14.1823633 32.6333862,13.9382232 32.8612498,13.7754627 C33.0891133,13.6127022 33.3332534,13.5313226 33.5936699,13.5313226 L34.8631981,13.5313226 C35.1887177,13.5313226 35.4816857,13.6778067 35.7421023,13.9707747 C36.0025188,14.2637428 36.1001748,14.5729873 36.0350703,14.8985069 L32.8124218,30.9140937 C32.6171097,32.0859659 32.6659377,32.9323186 32.9589058,33.4531501 C33.2518738,33.9739817 33.8540864,34.2343983 34.7655421,34.2343983 C38.0207422,34.2343983 40.6900077,33.3554941 42.7733355,31.5976858 C44.9868724,29.70967 46.0936401,27.0729575 46.0936401,23.6875484 C46.0936401,19.9115153 45.1170799,16.4935547 43.1639596,13.4336666 C41.3410468,10.5039861 38.8182668,8.22534621 35.5956183,6.59774542 C32.3729697,4.97014464 28.8410766,4.15634499 24.9999404,4.15634499 C21.1588042,4.15634499 17.6269111,5.10035366 14.4042625,6.98836949 C11.181614,8.87638533 8.62628102,11.4317183 6.73826518,14.6543668 C4.85024935,17.8770154 3.90624069,21.4089085 3.90624069,25.2500447 C3.90624069,29.0911809 4.85024935,32.623074 6.73826518,35.8457226 C8.62628102,39.0683711 11.181614,41.6237041 14.4042625,43.5117199 C17.6269111,45.3997357 21.1588042,46.3437444 24.9999404,46.3437444 C27.2134773,46.3437444 29.3944612,45.9856719 31.5428935,45.2695282 C33.6913259,44.5533846 35.6769978,43.5442714 37.4999106,42.2421917 C37.7603271,42.0468797 38.0370187,41.9817751 38.3299867,42.0468797 C38.6229548,42.1119842 38.8670948,42.2421917 39.0624069,42.4375037 L39.550687,43.0234398 C39.745999,43.2838564 39.8273785,43.5930994 39.794827,43.951172 C39.7622755,44.3092446 39.6157915,44.5859361 39.3553749,44.7812481 C37.272047,46.2786399 35.0096822,47.4342371 32.5682817,48.2480367 C30.1268813,49.0618364 27.6041013,49.468737 24.9999404,49.468737 C20.6379711,49.468737 16.6015229,48.3782443 12.8905943,46.1972604 C9.17966561,44.0162765 6.2337086,41.0703195 4.05272471,37.3593908 C1.87174083,33.6484622 0.781248137,29.612014 0.781248137,25.2500447 C0.781248137,20.8880754 1.87174083,16.8516272 4.05272471,13.1406986 C6.2337086,9.42976992 9.17966561,6.48381291 12.8905943,4.30282902 C16.6015229,2.12184513 20.6379711,1.03135245 24.9999404,1.03135245 Z M21.2890117,34.5273663 C23.1119246,34.5273663 24.7720769,33.9088787 26.2694686,32.671902 C27.6366529,31.5000298 28.7271455,29.9863615 29.5409452,28.1308972 C30.3547448,26.2754329 30.7616454,24.387417 30.7616454,22.4668482 C30.7616454,20.5462794 30.2733653,19.0000596 29.2968052,17.8281874 C28.320245,16.6563152 26.9205092,16.0703791 25.0975964,16.0703791 C23.5351001,16.0703791 22.0214319,16.5586592 20.5565916,17.5352193 C19.0917514,18.5117795 17.9036027,19.8789638 16.992147,21.6367721 C16.0806913,23.5247879 15.6249627,25.6081173 15.6249627,27.8867572 C15.6249627,29.970085 16.1295193,31.5976858 17.138631,32.769558 C18.1477427,33.9414302 19.5312034,34.5273663 21.2890117,34.5273663 Z"
                        id="icon-email-large"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <span>f@brill.co.za</span>
        </a>
        <a href="tel:+27825005099">
          <svg
            width="32px"
            height="51px"
            viewBox="0 0 32 51"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Icon Mobile</title>
            <g
              id="Layouts"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="IconPhone"
                transform="translate(-420.000000, -8782.000000)"
                fill={colour}
                fillRule="nonzero"
              >
                <g
                  id="Contact-Section"
                  transform="translate(0.000000, 1602.000000)"
                >
                  <g
                    id="Group-5"
                    transform="translate(100.000000, 7003.000000)"
                  >
                    <g
                      id="Group-3"
                      transform="translate(320.000000, 177.000000)"
                    >
                      <path
                        d="M18.7499553,40.8750075 C18.7499553,41.7213601 18.4407107,42.4537802 17.8222231,43.0722678 C17.2037355,43.6907554 16.4713154,44 15.6249627,44 C14.7786101,44 14.04619,43.6907554 13.4277024,43.0722678 C12.8092147,42.4537802 12.4999702,41.7213601 12.4999702,40.8750075 C12.4999702,40.0286548 12.8092147,39.2962347 13.4277024,38.6777471 C14.04619,38.0592595 14.7786101,37.7500149 15.6249627,37.7500149 C16.4713154,37.7500149 17.2037355,38.0592595 17.8222231,38.6777471 C18.4407107,39.2962347 18.7499553,40.0286548 18.7499553,40.8750075 Z M21.8749478,9.62508196 L9.37497765,9.62508196 L9.37497765,33.0625261 L21.8749478,33.0625261 L21.8749478,9.62508196 Z M23.8280682,6.50008941 C24.1535877,6.50008941 24.4302808,6.61402192 24.6581443,6.84188547 C24.8860079,7.06974901 24.9999404,7.34644205 24.9999404,7.67196161 L24.9999404,35.0156464 C24.9999404,35.341166 24.8860079,35.617859 24.6581443,35.8457226 C24.4302808,36.0735861 24.1535877,36.1875186 23.8280682,36.1875186 L7.4218573,36.1875186 C7.09633774,36.1875186 6.8196447,36.0735861 6.59178116,35.8457226 C6.36391762,35.617859 6.2499851,35.341166 6.2499851,35.0156464 L6.2499851,7.67196161 C6.2499851,7.34644205 6.36391762,7.06974901 6.59178116,6.84188547 C6.8196447,6.61402192 7.09633774,6.50008941 7.4218573,6.50008941 L23.8280682,6.50008941 Z M31.2499255,4.93759313 L31.2499255,45.5624963 C31.2499255,46.864576 30.7941969,47.9713452 29.8827413,48.8828009 C28.9712856,49.7942565 27.8645164,50.2499851 26.5624367,50.2499851 L4.68748882,50.2499851 C3.38540909,50.2499851 2.2786399,49.7942565 1.36718424,48.8828009 C0.455728577,47.9713452 0,46.864576 0,45.5624963 L0,4.93759313 C0,3.6355134 0.455728577,2.52874421 1.36718424,1.61728855 C2.2786399,0.705832885 3.38540909,0.250104308 4.68748882,0.250104308 L26.5624367,0.250104308 C27.8645164,0.250104308 28.9712856,0.705832885 29.8827413,1.61728855 C30.7941969,2.52874421 31.2499255,3.6355134 31.2499255,4.93759313 Z M28.1249329,4.93759313 C28.1249329,4.48186456 27.9784489,4.10751699 27.6854809,3.81454893 C27.3925128,3.52158088 27.0181652,3.37509686 26.5624367,3.37509686 L4.68748882,3.37509686 C4.23176025,3.37509686 3.85741268,3.52158088 3.56444463,3.81454893 C3.27147658,4.10751699 3.12499255,4.48186456 3.12499255,4.93759313 L3.12499255,45.5624963 C3.12499255,46.0182249 3.27147658,46.3925724 3.56444463,46.6855405 C3.85741268,46.9785085 4.23176025,47.1249925 4.68748882,47.1249925 L26.5624367,47.1249925 C27.0181652,47.1249925 27.3925128,46.9785085 27.6854809,46.6855405 C27.9784489,46.3925724 28.1249329,46.0182249 28.1249329,45.5624963 L28.1249329,4.93759313 Z"
                        id="icon-mobile-large"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <span>+27825005099</span>
        </a>
      </div>
      <SocialIcons isLarge />
    </ContactSectionInner>
  </ContactSectionAnimation>
)

export default ContactSection
